import { Injectable } from '@angular/core';
import gql from 'graphql-tag';

import { ApiMutation } from 'infrastructure/common/model/api.mutation';
import { TaskStatus } from 'task/model/task.status';
import { TaskType } from 'task/model/task.type';
import { IamUserTaskExportTaskOutput } from 'user/model/iam-user-task-export-task.output';
import { user } from 'user/model/user.fragments';

export interface CreateUserTaskExportTaskParams {
	readonly userId: string;
	readonly exportedTasksType: TaskType;
	readonly exportedTasksDueTimestamp: number;
	readonly exportedTasksParticipantId: string;
	readonly exportedTasksStatuses: TaskStatus[];
}

@Injectable({ providedIn: 'root' })
export class CreateUserTaskExportTaskApiMutation extends ApiMutation<
	IamUserTaskExportTaskOutput,
	CreateUserTaskExportTaskParams
> {
	client = 'iam';
	document = gql`
		mutation CreateUserTaskExportTask(
			$exportedTasksDueTimestamp: Long
			$exportedTasksParticipantId: UUID
			$exportedTasksStatuses: [TaskStatus]
			$exportedTasksType: TaskType!
			$userId: UUID!
		) {
			createUserTaskExportTask(
				exportedTasksDueTimestamp: $exportedTasksDueTimestamp
				exportedTasksParticipantId: $exportedTasksParticipantId
				exportedTasksStatuses: $exportedTasksStatuses
				exportedTasksType: $exportedTasksType
				userId: $userId
			) {
				id
				status
				dueTimestamp
				updateTimestamp
				creationTimestamp
				exportedTasksType
				exportedTaskStatuses
				exportedTasksDocumentUrl
				exportedTasksParticipant {
					...User
				}
				user {
					...User
				}
			}
		}
		${user}
	`;
	method = 'createUserTaskExportTask';
}
